import { Outlet, Route, Routes } from "react-router-dom";
import { AppShell } from "./layout/AppShell.js";
import { LoginPage } from "./pages/Login.js";
import { AcceptInvitePage } from "./pages/AcceptInvite.js";
import { DownloadPage } from "./pages/Download.js";
import { DashboardPage } from "./pages/Dashboard.js";
import { UsersPage } from "./pages/Users.js";
import { ApprovalsPage } from "./pages/Approvals.js";
import { ConnectorsPage } from "./pages/Connectors.js";
import { ConflictsPage } from "./pages/Conflicts.js";
import { WebhooksPage } from "./pages/Webhooks.js";
import { AuditLogPage } from "./pages/AuditLog.js";
import { SettingsPage } from "./pages/Settings.js";
import { NotificationsPage } from "./pages/Notifications.js";
import { NotFoundPage } from "./pages/NotFound.js";
import { RequireAuth } from "./auth/RequireAuth.js";

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/invite/:token" element={<AcceptInvitePage />} />
      <Route path="/download" element={<DownloadPage />} />
      <Route element={<ProtectedShell />}>
        <Route index element={<DashboardPage />} />
        <Route path="/users" element={<UsersPage />} />
        <Route path="/approvals" element={<ApprovalsPage />} />
        <Route path="/connectors" element={<ConnectorsPage />} />
        <Route path="/conflicts" element={<ConflictsPage />} />
        <Route path="/webhooks" element={<WebhooksPage />} />
        <Route path="/audit" element={<AuditLogPage />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="/notifications" element={<NotificationsPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
}

function ProtectedShell() {
  return (
    <RequireAuth>
      <AppShell>
        <Outlet />
      </AppShell>
    </RequireAuth>
  );
}
